import React from 'react'
import ReactMarkdown from 'react-markdown'
import cn from 'classnames'

function Markdown({ text, children, className }) {
  return (
    <ReactMarkdown
      parserOptions={{ commonmark: true }}
      className={cn('markdown-text', className)}
    >
      {text || children}
    </ReactMarkdown>
  )
}

export default Markdown
